import React from 'react'
import { useSelector } from 'react-redux'
import Info from '../../../info.json'

export default function Footer() {
  const system = useSelector((state) => state.system)

  if (system && system.isLoading === true)
    return (
      <footer className="container mx-auto items-center bottom-0 z-10">
        <hr className="mb-4 border-b-1 border-gray-300" />
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full md:w-4/12 px-4">
            <div className="text-sm text-gray-600 font-normal py-1 text-center md:text-left">
              Copyright © {new Date().getFullYear()}{' '}
              {/* <a
              href={'https://iarc.psu.ac.th/'}
              className="text-gray-600 hover:text-gray-800 text-sm font-normal py-1"
            >
              ศูนย์วิจัยระบบอัตโนมัติอัจฉริยะคณะวิศวกรรมศาสตร์
            </a>
            , <br /> */}
              <a
                href={system?.sponsor?.website}
                className="text-gray-600 hover:text-gray-800 text-sm font-normal py-1"
              >
                {system?.sponsor?.name}
              </a>{' '}
              Powered By{' '}
              <a
                href="https://iarc.psu.ac.th/"
                className="text-gray-600 hover:text-gray-800 text-sm font-normal py-1"
              >
                PSUIE
              </a>{' '}
              {/* Ver {Version?.version} */}
            </div>
          </div>
          <div className="w-full md:w-8/12 px-4">
            <ul className="flex flex-wrap list-none md:justify-end  justify-center">
              <li>
                <a
                  href="https://iarc.psu.ac.th/"
                  className="text-gray-700 hover:text-gray-900 text-sm font-normal block py-1 px-3"
                >
                  PSUIE
                </a>
              </li>
              <li>
                <a
                  href="https://iarc.psu.ac.th/about/"
                  className="text-gray-700 hover:text-gray-900 text-sm font-normal block py-1 px-3"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61568381156720"
                  className="text-gray-700 hover:text-gray-900 text-sm font-normal block py-1 px-3"
                >
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    )
  else {
    return <div></div>
  }
}
